import {createPreviewCropper} from "./shared_functions/image_cropper";

document.addEventListener('turbolinks:load', () => {

    const stationAudioControl = document.getElementById('stationAudioControl-00');
    const audioSelect = document.getElementById('audioSelect');
    const stationAudioSource = document.getElementById('stationAudioSource-00');
    const stationAudioSources = document.getElementsByClassName('audioSources');
    const stationAudioControls = document.getElementsByClassName('audioControls');
    const audioPlaceholder = document.getElementById('audioPlaceholder')
    const audioThumbPlaceholder = audioPlaceholder ? audioPlaceholder.dataset.audioThumb : ""

    const videoSelect = document.getElementById('videoSelect');
    const stationVideoControl = document.getElementById('stationVideoControl-00');
    const stationVideoSource = document.getElementById('stationVideoSource-00');
    const stationVideoSources = document.getElementsByClassName('videoSources');
    const stationVideoControls = document.getElementsByClassName('videoControls');

    const imageSelect = document.getElementById('imageSelect');
    const stationImageSrc = document.getElementById('stationImageSrc-00');
    const stationImageSources = document.getElementsByClassName('imageSources');
    const imagePlaceholder = document.getElementById('imagePlaceholder')
    const imageSrcPlaceholder = imagePlaceholder ? imagePlaceholder.dataset.src : ""

    const textSelect = document.getElementById('textSelect');
    const stationSelectedText = document.getElementById('stationSelectedText-00');
    const stationSelectedTexts = document.getElementsByClassName('selectedTexts');

    const websiteSelect = document.getElementById('websiteSelect');
    const stationSelectedWebsite = document.getElementById('stationSelectedWebsite-00');
    const stationSelectedWebsites = document.getElementsByClassName('selectedWebsites');

    const pdfSelect = document.getElementById('pdfSelect');
    const stationPdfSource = document.getElementById('stationPdfSource');

    const previewImageType = document.getElementById('previewImageType')
    const previewImageIdViaGallery = document.getElementById('previewImageIdViaGallery');
    const previewImageIdViaStation = document.getElementById('previewImageIdViaStation');
    const stationPreviewImages = document.getElementById('stationPreviewImages');

    const quizSelect = document.getElementById('quizSelect')

    const mediaTypeSelect = document.getElementById('mediaTypeSelect')

    const filterTagsSelect = document.getElementById('filterTagsSelect')

    const station_bt_beacon_group_id = document.getElementById('station_bt_beacon_group_id')
    const btStationBeaconOptions = document.getElementById('btStationBeaconOptions')

    if (stationAudioControl !== null && audioSelect !== null && stationAudioSource !== null &&
        stationVideoControl !== null && videoSelect !== null && stationVideoSource !== null &&
        imageSelect !== null && stationImageSrc !== null && textSelect !== null && stationSelectedText !== null &&
        pdfSelect !== null && stationPdfSource !== null && mediaTypeSelect !== null) {
        init()
    }

    if (previewImageIdViaGallery !== null && previewImageIdViaStation !== null && previewImageType != null) {
        initPreviewImageSelect()
    }

    if(filterTagsSelect !== null){
        filterTagsSelect.addEventListener('change', function(){
            filterTags(filterTagsSelect.value)
        })
    }

    // Only show beacon options if a beacon group is selected
    if (station_bt_beacon_group_id !== null && btStationBeaconOptions !== null){
        station_bt_beacon_group_id.addEventListener('change', function(){
            if (station_bt_beacon_group_id.value !== ""){
                btStationBeaconOptions.classList.remove('hidden')
            } else {
                btStationBeaconOptions.classList.add('hidden')
            }
        })
    }

    // Initializes the preview image selection logic, handling changes in preview type and updating the image source accordingly.
    function initPreviewImageSelect() {
        // init preview image
        let mediaEntry

        // change listener for preview type
        previewImageType.addEventListener('change', (e) => {
            if (e.target.value === "none" || e.target.value === "first_station_media_entry") {
                mediaEntry = previewImageType.options[previewImageType.selectedIndex].dataset.mediaId
                get_preview_image(mediaEntry, false)
            } else if (e.target.value === "media_gallery_image") {
                mediaEntry = previewImageIdViaGallery.options[previewImageIdViaGallery.selectedIndex].value
                get_preview_image(mediaEntry, false)
            } else if (e.target.value === "any_station_media_entry") {
                mediaEntry = previewImageIdViaStation.options[previewImageIdViaStation.selectedIndex].value
                get_preview_image(mediaEntry, false)
            }
        })

        const previewImageSelect2 = $("#previewImageIdViaGallery").select2();
        previewImageSelect2.data('select2').$container.addClass("wrap")
        previewImageSelect2.on('select2:selecting', function(e) {
            let mediaEntry = e.params.args.data.element.value
            get_preview_image(mediaEntry, false)
        });
        $("#previewImageIdViaGallery").hide()

        const previewImageIdViaStationSelect2 = $("#previewImageIdViaStation").select2();
        previewImageIdViaStationSelect2.data('select2').$container.addClass("wrap")
        previewImageIdViaStationSelect2.on('select2:selecting', function(e) {
            let mediaEntry = e.params.args.data.element.value
            get_preview_image(mediaEntry, false)
        });
        $("#previewImageIdViaStation").hide()

        addCropper(true)
    }

    // Main initialization function that sets up media players, event listeners for media controls, and handles AJAX calls for loading media selections.
    function init() {
        //Stop all media when changing the media type
        mediaTypeSelect.addEventListener('change', function(e) {
            stopMedia(null)
        })

        //Stop all media except the audio that started playing
        for (let control of stationAudioControls){
            control.addEventListener('play', function(e) {
                stopMedia(e.target)
            })
        }

        //Stop all media except the video that started playing
        for (let control of stationVideoControls){
            control.addEventListener('play', function(e) {
                stopMedia(e.target)
            })
        }

        // get the Options for the still empty select-elements
        // they are loaded by AJAX t reduce the initial loading time
        let currentHref = window.location.href
        let urlArray = currentHref.split("/")
        if (urlArray[urlArray.length -1] === 'edit'){
            // first load the options for the current media_type to get them first
            urlArray[urlArray.length -1] = "get_select"
            let selected_type = mediaTypeSelect.dataset.initialValue
            urlArray.push(selected_type)
            if (selected_type !== "nil") {
                $.rails.ajax({
                    url: urlArray.join("/"),
                    type: "get",
                    success: function () {
                        if (selected_type === "quiz" && quizSelect !== null) {
                            loadQuizSelect()
                        } else {
                            loadSelects(selected_type)
                        }
                    }
                })
            }
            urlArray[urlArray.length -1] = 'all'
        } else {
            urlArray[urlArray.length -1] = "get_select"
            urlArray.push("all")
        }
        // Load all selects
        $.rails.ajax({
            url: urlArray.join("/"),
            type: "get",
            data: "Second AJAX",
            success: function () {
                loadSelects()
                if (quizSelect !== null){
                    loadQuizSelect() //separated because not every organization can use quizzes
                }
            }
        })

        //Destroy Select2 before cache, otherwise 2 select2 fields could appear on reloading
        $(document).on("turbolinks:before-cache", removeSelect2)

        // Destroys Select2 instances to prevent duplication issues when Turbolinks caches the page.
        function removeSelect2(){
            $("#audioSelect").select2('destroy');
            getSpinnerForType('audio').classList.remove('hidden')
            $("#videoSelect").select2('destroy');
            getSpinnerForType('video').classList.remove('hidden')
            $("#imageSelect").select2('destroy');
            getSpinnerForType('image').classList.remove('hidden')
            $("#websiteSelect").select2('destroy');
            getSpinnerForType('website').classList.remove('hidden')
            $("#textSelect").select2('destroy');
            getSpinnerForType('text').classList.remove('hidden')
            $(document).off("turbolinks:before-cache", removeSelect2)
        }
    }

    // Triggers the loading of Select2 dropdowns for specified media types or all types.
    function loadSelects(selectType='all') {
        if (selectType === "audio"){
            loadAudioSelect()
        } else if (selectType === "video") {
            loadVideoSelect()
        } else if (selectType === "image") {
            loadImageSelect()
        } else if (selectType === "text") {
            loadTextSelect()
        } else if (selectType === "website") {
            loadWebsiteSelect()
        } else if (selectType === "pdf") {
            loadPdfSelect()
        } else if (selectType === "all") {
            loadAudioSelect()
            loadVideoSelect()
            loadImageSelect()
            loadTextSelect()
            loadWebsiteSelect()
            loadPdfSelect()
        }
    }

    // Initializes the Select2 dropdown for audio selection and handles selection events.
    function loadAudioSelect() {
        // ensure this function only runs one time
        if (audioSelect.dataset.loaded === "true"){
            return
        } else {
            audioSelect.dataset.loaded = "true"
        }
        // Initialize the showed content with the currently selected option
        let audioSrc = audioSelect.value.split(";")[1]
        if(audioSrc != null) {
            get_srcs_from_option(audioSelect.selectedOptions[0], "audio")
        } else {
            document.getElementById('audio_00_station_media_entry_warning').classList.add('hidden')
        }

        if (document.getElementById("select2-audioSelect-container") !== null){
            return //select2 is already build
        }
        const audioSelect2 = $("#audioSelect").select2();
        audioSelect2.data('select2').$container.addClass("wrap")
        audioSelect2.on('select2:selecting', function(e) {
            stopMedia(null)
            get_srcs_from_option(e.params.args.data.element, "audio")
        });
        $("#audioSelect").hide()
        getSpinnerForType('audio').classList.add('hidden')
    }

    // Initializes the Select2 dropdown for video selection and handles selection events.
    function loadVideoSelect() {
        // ensure this function only runs one time
        if (videoSelect.dataset.loaded === "true"){
            return
        } else {
            videoSelect.dataset.loaded = "true"
        }
        // Initialize the showed content with the currently selected option
        let videoSrc = videoSelect.value.split(";")[1]
        if (videoSrc != null) {
            get_srcs_from_option(videoSelect.selectedOptions[0], "video")
        } else {
            document.getElementById('video_00_station_media_entry_warning').classList.add('hidden')
        }
        const videoSelect2 = $("#videoSelect").select2();
        videoSelect2.data('select2').$container.addClass("wrap")
        videoSelect2.on('select2:selecting', function(e) {
            stopMedia(null)
            get_srcs_from_option(e.params.args.data.element, "video")
        });
        $("#videoSelect").hide()
        getSpinnerForType('video').classList.add('hidden')
    }

    // Initializes the Select2 dropdown for image selection and handles selection events.
    function loadImageSelect() {
        // ensure this function only runs one time
        if (imageSelect.dataset.loaded === "true"){
            return
        } else {
            imageSelect.dataset.loaded = "true"
        }
        // Initialize the showed content with the currently selected option
        let imageSrc = imageSelect.value.split(";")[1]
        if (typeof imageSrc !== 'undefined' && imageSrc !== null && imageSrc !== "") {
            get_srcs_from_option(imageSelect.selectedOptions[0], "image")
        } else {
            document.getElementById('image_00_station_media_entry_warning').classList.add('hidden')
        }

        if (document.getElementById("select2-imageSelect-container") !== null){
            return //select2 is already build
        }
        const imageSelect2 = $("#imageSelect").select2();
        imageSelect2.data('select2').$container.addClass("wrap")
        imageSelect2.on('select2:selecting', function(e) {
            get_srcs_from_option(e.params.args.data.element, "image")
        });
        $("#imageSelect").hide()
        getSpinnerForType('image').classList.add('hidden')
    }

    // Initializes the Select2 dropdown for text selection and updates the displayed text content.
    function loadTextSelect() {
        // ensure this function only runs one time
        if (textSelect.dataset.loaded === "true"){
            return
        } else {
            textSelect.dataset.loaded = "true"
        }
        // Initialize the showed content with the currently selected option
        let html = textSelect.value.split(";")[2]
        if (typeof html !== 'undefined' && html !== null && html !== "") {
            get_srcs_from_option(textSelect.selectedOptions[0], "text")
        } else {
            stationSelectedText.innerHTML = I18n.t('js.please_select_a_text')
            document.getElementById('text_00_station_media_entry_warning').classList.add('hidden')
        }

        if (document.getElementById("select2-textSelect-container") !== null){
            return //select2 is already build
        }
        const textSelect2 = $("#textSelect").select2();
        textSelect2.data('select2').$container.addClass("wrap")
        textSelect2.on('select2:selecting', function(e) {
            get_srcs_from_option(e.params.args.data.element, "text")
        });
        $("#textSelect").hide()
        getSpinnerForType('text').classList.add('hidden')
    }

    // Initializes the Select2 dropdown for website selection and updates the displayed link.
    function loadWebsiteSelect(){
        // ensure this function only runs one time
        if (websiteSelect.dataset.loaded === "true"){
            return
        } else {
            websiteSelect.dataset.loaded = "true"
        }
        // Initialize the showed content with the currently selected option
        let url = websiteSelect.value.split(";")[2]
        if (typeof url !== 'undefined' && url !== null && url !== "") {
            get_srcs_from_option(websiteSelect.selectedOptions[0], "website")
        } else {
            document.getElementById('website_00_station_media_entry_warning').classList.add('hidden')
        }

        if (document.getElementById("select2-websiteSelect-container") !== null){
            return //select2 is already build
        }
        const websiteSelect2 = $("#websiteSelect").select2();
        websiteSelect2.data('select2').$container.addClass("wrap")
        websiteSelect2.on('select2:selecting', function(e) {
            get_srcs_from_option(e.params.args.data.element, "website")
        });
        $("#websiteSelect").hide()
        getSpinnerForType('website').classList.add('hidden')
    }

    // Initializes the Select2 dropdown for PDF selection and handles warning messages.
    function loadPdfSelect(){
        // ensure this function only runs one time
        if (pdfSelect.dataset.loaded === "true"){
            return
        } else {
            pdfSelect.dataset.loaded = "true"
        }
        let pdfSrc = pdfSelect.value.split(";")[1]
        if (typeof pdfSrc === 'undefined' || pdfSrc === null || pdfSrc === "nil/pdf/nil" || pdfSrc === "") {
            stationPdfSource.src = "/uploads/pdf/default_pdf"
        } else {
            stationPdfSource.src = pdfSrc
        }

        if (document.getElementById("select2-pdfSelect-container") !== null){
            return //select2 is already build
        }
        const pdfSelect2 = $("#pdfSelect").select2();
        pdfSelect2.data('select2').$container.addClass("wrap")
        pdfSelect2.on('select2:selecting', function (e) {
            const pdfStationMediaEntryWarning = document.getElementById('pdf_station_media_entry_warning')
            if (pdfStationMediaEntryWarning !== null) {
                if (e.params.args.data.element.dataset.warningMsg === "") {
                    pdfStationMediaEntryWarning.classList.add("hidden")
                } else {
                    pdfStationMediaEntryWarning.classList.remove("hidden")
                    const pdfStationMediaEntryWarningMsg = document.getElementById('pdf_station_media_entry_warning_msg')
                    if (pdfStationMediaEntryWarningMsg !== null) {
                        pdfStationMediaEntryWarningMsg.innerHTML = e.params.args.data.element.dataset.warningMsg
                    }
                }

            }

            pdfSrc = e.params.args.data.id.split(";")[1]
            if (pdfSrc === "nil/pdf/nil" || pdfSrc === "")
                stationPdfSource.src = "/uploads/pdf/default_pdf"
            else {
                stationPdfSource.src = pdfSrc
            }
        });
        $("#pdfSelect").hide()
        getSpinnerForType('pdf').classList.add('hidden')
    }

    // Initializes the Select2 dropdown for quiz selection, handles warnings, and fetches quiz overview data via AJAX.
    function loadQuizSelect() {
        // ensure this function only runs one time
        if (quizSelect === null) {
            return
        } else if (quizSelect.dataset.loaded === "true"){
            return
        } else {
            quizSelect.dataset.loaded = "true"
        }
        if (document.getElementById("select2-quizSelect-container") !== null){
            return //select2 is already build
        }
        const quizSelect2 = $("#quizSelect").select2();
        quizSelect2.data('select2').$container.addClass("wrap")
        quizSelect2.on('select2:selecting', function(e) {

            const quizStationMediaEntryWarning = document.getElementById('quiz_station_media_entry_warning')
            if (quizStationMediaEntryWarning !== null) {
                if (e.params.args.data.element.dataset.warningMsg === "") {
                    quizStationMediaEntryWarning.classList.add("hidden")
                } else {
                    quizStationMediaEntryWarning.classList.remove("hidden")
                    const quizStationMediaEntryWarningMsg = document.getElementById('quiz_station_media_entry_warning_msg')
                    if (quizStationMediaEntryWarningMsg !== null) {
                        quizStationMediaEntryWarningMsg.innerHTML = e.params.args.data.element.dataset.warningMsg
                    }
                }
            }

            const mediaEntryId = e.params.args.data.id.split(";")[0]
            $.rails.ajax({
                url: `/media_entries/${mediaEntryId}/quiz_questions/station_quiz_overview`,
                type: "get",
                data: "",
            })
        });
        $("#quizSelect").hide()
        getSpinnerForType('quiz').classList.add('hidden')
    }

    // Helper function to remove leading double slashes from a URL string.
    function removeSlashes(url) {
        if (url[0] === "/" && url[1] === "/") {
            return url.substring(2);
        } else {
            return url
        }
    }

    // Helper function to find the loading spinner element associated with a specific media type.
    function getSpinnerForType(type){
        let spinnerContainer
        if (type === "quiz") {
            spinnerContainer = document.getElementById('quizzesForStation')
        } else {
            spinnerContainer = document.getElementById(type + 'sForStation')
        }
        return spinnerContainer.getElementsByClassName('spinner')[0]
    }

    // Filters the options in all media select dropdowns based on the selected tag ID.
    function filterTags(tag_id){
        if(tag_id !== "") {
            filterTagType(tag_id, audioSelect.options)
            filterTagType(tag_id, videoSelect.options)
            filterTagType(tag_id, imageSelect.options)
            filterTagType(tag_id, textSelect.options)
            filterTagType(tag_id, websiteSelect.options)
            filterTagType(tag_id, pdfSelect.options)
            filterTagType(tag_id, quizSelect.options)
        }
    }

    // Helper function that iterates through options of a specific select list and disables those that don't match the selected tag.
    function filterTagType(tag_id,optionList){
        if(tag_id === "all") {
            for (let mediaOption of optionList) {
                //Skip placeholder
                if (mediaOption.value === '') {
                    continue
                }
                mediaOption.disabled = false // CSS of select2 hides disabled options
            }
        } else if(tag_id === "no_tag"){
            for (let mediaOption of optionList) {
                //Skip placeholder
                if (mediaOption.value === '') {
                    continue
                }
                // Disable if there is a tag
                mediaOption.disabled = mediaOption.dataset['tags'] !== ''; // CSS of select2 hides disabled options
            }
        } else {
            for (let mediaOption of optionList) {
                console.log(mediaOption)
                //Skip placeholder
                if (mediaOption.value === '') {
                    continue
                }
                // Disable if the tag_id is not included
                mediaOption.disabled = !mediaOption.dataset.tags.split('_').includes(tag_id); // CSS of select2 hides disabled options
            }
        }
    }

    // Extracts media sources and metadata from the selected option's dataset and updates the UI elements (players, images, text) for all supported languages.
    /**
     * @param optionElement [<option value="42;/uploads/4/image/42/de/21/DE_2.png"
     *                               data-languages="de_en"
     *                               data-file-de="/path/file.ext
     *                               data-file-en="/path/file2.ext">]
     * @param type [audio, video, image, website, text]
     */
    function get_srcs_from_option(optionElement, type){
        // working for audio, video, image, website and text
        let elementData = optionElement.dataset
        let stationSources = []
        // get sources based on type
        if(type === "audio") {
            stationSources = stationAudioSources
        } else if(type === "video") {
            stationSources = stationVideoSources
        } else if(type === "image") {
            stationSources = stationImageSources
        } else if(type === "text"){
            stationSources = stationSelectedTexts
        } else if(type === "website"){
            stationSources = stationSelectedWebsites
        }
        //hide all and reset src. Languages without src showing this screen, because they are skipped in the later part of the function
        for(let srcElement of stationSources){
            let divContainer = srcElement.closest('li')
            if(type ==="audio" || type === "video") {
                srcElement.removeAttribute("src")
                if(type === "audio"){
                    divContainer.getElementsByTagName('img')[0].src = audioThumbPlaceholder
                }
            } else if(type === "image"){
                srcElement.src = imageSrcPlaceholder
            } else if(type === "text"){
                srcElement.innerHTML = ""
            } else if(type === "website"){
                srcElement.getElementsByTagName('div')[0].innerHTML = I18n.t('js.no_url')
                srcElement.getElementsByTagName('iframe')[0].src = "about:blank"
            }
            divContainer.classList.add('hidden')
            // Show tooltip for empty sources
            divContainer.getElementsByClassName('tooltip')[0].classList.remove('hidden')
            // Hide additional tooltip
            divContainer.getElementsByClassName('tooltip')[1].classList.add('hidden')
        }

        // Check if there are sources
        if (elementData.languages !== "") {
            // Set src for all specified languages
            for (let lang of elementData.languages.split('_')) {
                let langSrc
                let divContainer
                // the language key is needed to get the dataset attributes. The "-" between two words is changed to camelCase
                // With numbers the key stays the same
                // the language key for "00" is "-00" and for languages it capitalizes the first letter like "De", "En" etc.
                let langKey = lang.match(/^\d/)? "-" + lang : lang.charAt(0).toUpperCase() + lang.charAt(1)


                if (type === "text") {
                    langSrc = document.getElementById('stationSelectedText-' + lang)
                    langSrc.innerHTML = elementData['file' + langKey]
                    divContainer = langSrc.closest('li')
                } else if (type === "website") {
                    langSrc = document.getElementById('stationSelectedWebsite-' + lang)
                    let url = elementData['file' + langKey]
                    if(!url.startsWith('http')){
                        url = "https://" + url
                    }
                    langSrc.getElementsByTagName('div')[0].innerHTML = `<a href="${url}" class="border-b border-blue-500 text-blue-500" target="_blank"> ${removeSlashes(url)} </a>`
                    let iframe = langSrc.getElementsByTagName('iframe')[0]
                    iframe.src = url
                    divContainer = langSrc.closest('li')
                } else {
                    if (type === "audio") {
                        langSrc = document.getElementById('stationAudioSource-' + lang)
                        let thumbSrc = document.getElementById('audioThumb-' + lang)
                        thumbSrc.src = elementData['audioThumb']
                    } else if (type === "video") {
                        langSrc = document.getElementById('stationVideoSource-' + lang)
                    } else if (type === "image") {
                        langSrc = document.getElementById('stationImageSrc-' + lang)
                    }
                    divContainer = langSrc.closest('li')
                    langSrc.src = elementData['file' + langKey]
                }
                // Remove tooltip for used sources
                divContainer.getElementsByClassName('tooltip')[0].classList.add('hidden')
                // Add tooltip for other warnings (at the moment only uncompressed videos)
                if (elementData['warning_' + lang] !== undefined) {
                    let additional_tooltip = document.getElementById(`${type}_${lang}_additional_station_media_entry_warning`)
                    let additional_tooltip_msg = document.getElementById(`${type}_${lang}_additional_station_media_entry_warning_msg`)
                    if(additional_tooltip !== null && additional_tooltip_msg !== null) {
                        additional_tooltip.classList.remove('hidden')
                        additional_tooltip_msg.innerHTML = I18n.t('js.'+elementData['warning_' + lang])
                    }

                }
            }
        }

        if (elementData.languages.split('_')[0] === "00" || elementData.languages === ""){
            // show "no_language"
            let divContainer
            if(type === "audio"){
                divContainer = stationAudioSource.closest('li')
                stationAudioControl.load()
            } else if(type === "video"){
                divContainer = stationVideoSource.closest('li')
                stationVideoControl.load()
            } else if(type === "image"){
                divContainer = stationImageSrc.closest('li')
            }  else if(type === "text"){
                divContainer = stationSelectedText.closest('li')
            } else if(type === "website"){
                divContainer = stationSelectedWebsite.closest('li')
            }
            // Show Container of no language
            divContainer.classList.remove('hidden')
        } else {
            //show all except no_language
            for (let srcElement of stationSources) {
                //Skip "no_language", it should not be shown when languages are defined
                if(srcElement.id.slice(-2) === "00"){
                    continue
                }
                let divContainer = srcElement.closest('li')
                if(type === "audio" || type === "video"){
                    //Load to use the new src
                    srcElement.parentElement.load()
                } else if(type === "image" || type === "text" || type === "website"){
                    //placeholder
                }
                // Show the container
                divContainer.classList.remove('hidden')
            }
        }
    }

    // Pauses all media players (audio and video), optionally skipping a specific element (e.g., the one currently starting).
    function stopMedia(skipElement){
        for (let control of stationAudioControls){
            if(control === skipElement) {
                continue
            }
            control.pause()
        }
        for (let control of stationVideoControls){
            if(control === skipElement) {
                continue
            }
            control.pause()
        }
    }

    // Function should check if the website is available or blocked due to Cross-Origin-Policy
    // doesn't work every time, so it's not used at the moment
    // Attempts to check if an iframe's content is blocked by Cross-Origin policy.
    function checkWebsiteCrossOrigin(iframe) {
        console.log("Diese asynchrone Funktion wird mit einem Zeitversatz aufgerufen.");
        try {
            // Versuch, auf das Dokument des iframes zuzugreifen
            let iframeDocument = iframe.contentWindow.document;
            console.log(`Iframe loaded successfully. ${iframe.src}`);
        } catch (e) {
            console.log(`Iframe loading blocked or denied (Cross-Origin). ${iframe.src}`);
            //TODO: When used get path from a html element or create a route, because the assets path changes on server
            iframe.src = "/assets/media_gallery/html_placeholder"
        }
    }

    function get_preview_image(mediaEntry, initial) {
        if (mediaEntry === ""){
            mediaEntry = "nil"
        }
        let base_url = window.location.href.split("/stations/")[0]
        let url = base_url + `/stations/update_station_preview/${mediaEntry}`
        $.rails.ajax({
            url: url,
            type: "get",
            data: "",
            success: () => addCropper(initial)
        })
    }

    function addCropper(initial) {
        if (stationPreviewImages !== null) {
            createPreviewCropper(stationPreviewImages.getElementsByTagName('img'), "station", initial)
        }
    }
});